import {CrudAddHeader} from 'app/Components/Crud'
import {CrudAction, Type} from 'lib/crud'
import {name, newUser, User} from 'lib/users'
import * as React from 'react'
import {connect, MapDispatchToProps} from 'react-redux'
import {Form} from './Form'

type DispatchToProps = {
    readonly handleSubmit: (user: User) => void,
}

type AddProps = DispatchToProps

class AddComponent extends React.Component<AddProps> {
    public render = () => (<>
        <CrudAddHeader actionName={name}/>
        <Form initialValues={newUser()} handleSubmit={this.props.handleSubmit}/>
    </>)
}

const mapDispatchToProps: MapDispatchToProps<DispatchToProps, {}> = dispatch => ({
    handleSubmit: (user: User) => {
        delete user.id
        dispatch(CrudAction.execute(name, Type.CREATE, user))
    },
})

export const Add = connect(null, mapDispatchToProps)(AddComponent)